import { Button } from "components/button";
import Modal from "components/modal";
import CloseIcon from "assets/icons/close.svg";

export default function StreetNumberModal({
  setModalOpen,
  modalOpen,
  onCreateAccount,
  onCompleteAddress,
}) {
  return (
    <Modal
      setModalOpen={setModalOpen}
      modalOpen={modalOpen}
      className="flex flex-col justify-between"
    >
      <div className="flex flex-col justify-between space-y-8">
        <div className="flex flex-col justify-between space-y-2">
          <div className="flex justify-between ">
            <div className="flex flex-col space-y-2 -mt-1">
              <h2 className="text-4xl font-semibold leading-none">
                No street number
              </h2>
            </div>
            <div className="cursor-pointer" onClick={() => setModalOpen(false)}>
              <img src={CloseIcon} alt="" variant="secondary" />
            </div>
          </div>
          <p>Your address may be missing a street number.</p>
        </div>
        <div className="flex justify-end space-x-2 mt-2">
          <Button className="" variant="secondary" onClick={onCreateAccount}>
            Create Account
          </Button>
          <Button className="" onClick={onCompleteAddress}>
            Complete Address
          </Button>
        </div>
      </div>
    </Modal>
  );
}
